import React, { Component } from 'react'
import { connect } from 'react-redux'
import { _DOTNET, _JAVA, _PHP } from '../../../actions/types'

class VaultResLookupFullSample extends Component {
    getOrderId() {
        const { progLangId } = this.props;
        switch(progLangId) {
            case _DOTNET:
                return `"Test" + DateTime.Now.ToString("yyyyMMddhhmmss")`;
            case _JAVA:
                return `"Test"+createDate.getTime()`;
            case _PHP:
                return `'ord-'.date("dmy-G:i:s")`;
            default:
                return "";
        }
    }

    getValue(val, id) {
        return (
            <span className= {this.props.onEditId === id ? 'codeValue' : ''}>{val}</span>
        );
    }

    renderDOTNET() {
        const { storeId, apiToken } = this.props;
         return (
            <pre className="sampleCode">
{
`namespace Moneris
{
using System;
using System.Text;
using System.Collections;
public class TestCanadaResLookupFull 
{
public static void Main(string[] args) 
{
string store_id = "`}{this.getValue(storeId, "storeId")}{`";
string api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
string data_key = "pi3ZMZoTTM8pLM9wuwws2KBxw";
string processing_country_code = "CA";
bool status_check = false;
ResLookupFull resLookupFull = new ResLookupFull(data_key);
HttpsPostRequest mpgReq = new HttpsPostRequest(); 
mpgReq.SetProcCountryCode(processing_country_code);
mpgReq.SetTestMode(true); //false or comment out this line for production transactions 
mpgReq.SetStoreId(store_id);
mpgReq.SetApiToken(api_token); 
mpgReq.SetTransaction(resLookupFull); 
mpgReq.SetStatusCheck(status_check); 
mpgReq.Send();
try
{
Receipt receipt = mpgReq.GetReceipt();
Console.WriteLine("DataKey = " + receipt.GetDataKey()); 
Console.WriteLine("ResponseCode = " + receipt.GetResponseCode()); 
Console.WriteLine("Message = " + receipt.GetMessage()); 
Console.WriteLine("TransDate = " + receipt.GetTransDate()); 
Console.WriteLine("TransTime = " + receipt.GetTransTime()); 
Console.WriteLine("Complete = " + receipt.GetComplete()); 
Console.WriteLine("TimedOut = " + receipt.GetTimedOut()); 
Console.WriteLine("ResSuccess = " + receipt.GetResSuccess()); 
Console.WriteLine("PaymentType = " + receipt.GetPaymentType()); 
Console.WriteLine("Cust ID = " + receipt.GetResDataCustId());
Console.WriteLine("Phone = " + receipt.GetResDataPhone()); 
Console.WriteLine("Email = " + receipt.GetResDataEmail()); 
Console.WriteLine("Note = " + receipt.GetResDataNote());
Console.WriteLine("Pan = " + receipt.GetResDataPan()); 
Console.WriteLine("MaskedPan = " + receipt.GetResDataMaskedPan()); 
Console.WriteLine("Exp Date = " + receipt.GetResDataExpdate()); 
Console.WriteLine("Crypt Type = " + receipt.GetResDataCryptType()); 
Console.WriteLine("Avs Street Number = " + receipt.GetResDataAvsStreetNumber()); 
Console.WriteLine("Avs Street Name = " + receipt.GetResDataAvsStreetName()); 
Console.WriteLine("Avs Zipcode = " + receipt.GetResDataAvsZipcode()); 
Console.ReadLine();
}
catch (Exception e)
{
Console.WriteLine(e);
}
}
}
} 
`}
            </pre>
        )
    }

    renderJAVA() {
        const { storeId, apiToken } = this.props;
        return (
            <pre className="sampleCode">
{
`package Canada;
import JavaAPI.*;
public class TestCanadaResLookupFull
{
public static void main(String[] args)
{
String store_id = "`}{this.getValue(storeId, "storeId")}{`";
String api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
String data_key = "pi3ZMZoTTM8pLM9wuwws2KBxw";
String processing_country_code = "CA";
boolean status_check = false;
ResLookupFull resLookupFull = new ResLookupFull(data_key);
HttpsPostRequest mpgReq = new HttpsPostRequest(); 
mpgReq.setProcCountryCode(processing_country_code);
mpgReq.setTestMode(true); //false or comment out this line for production transactions 
mpgReq.setStoreId(store_id);
mpgReq.setApiToken(api_token);
mpgReq.setTransaction(resLookupFull);
mpgReq.setStatusCheck(status_check);
mpgReq.send();
try
{
Receipt receipt = mpgReq.getReceipt();
System.out.println("DataKey = " + receipt.getDataKey()); 
System.out.println("ResponseCode = " + receipt.getResponseCode()); 
System.out.println("Message = " + receipt.getMessage()); 
System.out.println("TransDate = " + receipt.getTransDate()); 
System.out.println("TransTime = " + receipt.getTransTime()); 
System.out.println("Complete = " + receipt.getComplete()); 
System.out.println("TimedOut = " + receipt.getTimedOut()); 
System.out.println("ResSuccess = " + receipt.getResSuccess()); 
System.out.println("PaymentType = " + receipt.getPaymentType()); 
System.out.println("Cust ID = " + receipt.getResCustId());
System.out.println("Phone = " + receipt.getResPhone());
System.out.println("Email = " + receipt.getResEmail()); 
System.out.println("Note = " + receipt.getResNote()); 
System.out.println("Pan = " + receipt.getResPan()); 
System.out.println("MaskedPan = " + receipt.getResMaskedPan()); 
System.out.println("Exp Date = " + receipt.getResExpdate()); 
System.out.println("Crypt Type = " + receipt.getResCryptType()); 
System.out.println("Avs Street Number = " + receipt.getResAvsStreetNumber()); 
System.out.println("Avs Street Name = " + receipt.getResAvsStreetName()); 
System.out.println("Avs Zipcode = " + receipt.getResAvsZipcode());
}
catch (Exception e) 
{ 
e.printStackTrace(); 
}
}
}
`}
</pre>
        )
    }

    renderPHP() {
        const { storeId, apiToken } = this.props;

        return (
            <pre className="sampleCode">
{`<?php
##
## Example php -q TestResLookupFull.php store3 yesguy
##
require "../../mpgClasses.php";
/**************************** Request Variables *******************************/ 
$store_id='`}{this.getValue(storeId, "storeId")}{`';
$api_token='`}{this.getValue(apiToken, "apiToken")}{`';
/************************* Transactional Variables ****************************/ 
$type='res_lookup_full'; //will return both the full & masked card number 
$data_key='t8RCndWBNFNt4Dx32CCnl2tlz';
/*********************** Transactional Associative Array **********************/ 
$txnArray=array('type'=>$type,
'data_key'=>$data_key
);
/**************************** Transaction Object *****************************/
$mpgTxn = new mpgTransaction($txnArray);
/****************************** Request Object *******************************/
$mpgRequest = new mpgRequest($mpgTxn);
$mpgRequest->setProcCountryCode("CA"); //"US" for sending transaction to US environment 
$mpgRequest->setTestMode(true); //false or comment out this line for production transactions 
/***************************** HTTPS Post Object *****************************/ 
$mpgHttpPost =new mpgHttpsPost($store_id,$api_token,$mpgRequest); 
/******************************* Response ************************************/ 
$mpgResponse=$mpgHttpPost->getMpgResponse();
print("\\nDataKey = " . $mpgResponse->getDataKey());
print("\\nResponseCode = " . $mpgResponse->getResponseCode());
print("\\nMessage = " . $mpgResponse->getMessage());
print("\\nTransDate = " . $mpgResponse->getTransDate());
print("\\nTransTime = " . $mpgResponse->getTransTime());
print("\\nComplete = " . $mpgResponse->getComplete());
print("\\nTimedOut = " . $mpgResponse->getTimedOut());
print("\\nResSuccess = " . $mpgResponse->getResSuccess());
print("\\nPaymentType = " . $mpgResponse->getPaymentType());
//----------------- ResolveData ------------------------------
print("\\n\\nCust ID = " . $mpgResponse->getResDataCustId());
print("\\nPhone = " . $mpgResponse->getResDataPhone());
print("\\nEmail = " . $mpgResponse->getResDataEmail());
print("\\nNote = " . $mpgResponse->getResDataNote());
print("\\nPan = " . $mpgResponse->getResDataPan());
print("\\nMasked Pan = " . $mpgResponse->getResDataMaskedPan());
print("\\nExp Date = " . $mpgResponse->getResDataExpDate());
print("\\nCrypt Type = " . $mpgResponse->getResDataCryptType());
print("\\nAvs Street Number = " . $mpgResponse->getResDataAvsStreetNumber());
print("\\nAvs Street Name = " . $mpgResponse->getResDataAvsStreetName());
print("\\nAvs Zipcode = " . $mpgResponse->getResDataAvsZipcode());
?>
`}
            </pre>
        )
    }

    render() {
        switch(this.props.progLangId) {
            case _DOTNET: 
                return this.renderDOTNET()
            case _JAVA:
                return this.renderJAVA()
            case _PHP:
                return this.renderPHP()

            default:
                return null
        }
        
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const {loading } = state.vault.main;
    const { storeId, apiToken, order_id, pan, expdate, onEditId} = state.vault.main.config;
    return { mode, storeId, apiToken, order_id, pan, expdate, onEditId, loading, progLangId: state.common.progLangList.selection };
  }
  
  export default connect(mapStateToProps, {})(VaultResLookupFullSample)